import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BlockchainApplicationListModel } from '../model/BlockchainApplicationListModel';
import { BlockchainDetailModelResponse } from '../model/BlockchainDetailModelResponse';
import { BlockchainDashboardModel } from '../model/BlockchainDashboardModel';
import { BlockchainAuditAssetWrapperResponse } from '../model/BlockchainAuditAssetWrapperResponse';
import { BlockchainPendingDocsView } from '../model/BlockchainPendingDocsView';

@Injectable({
  providedIn: 'root'
})
export class BlockchainApplicationService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  
  fetchBlockchainApplicationList(page: number,
    size: number, filteredListParams: {
      boardId: number,
      lotteryId: number,
      schemeId: number,
      blockchainTransactionType: string,
      filterText: string,
    }) {
    return this.httpClient.post<{data: Page<BlockchainApplicationListModel>, status: string, errorMessage: string}>(
        ApiUrls.blockchainApplicationListFetchPageByFilterUrl + `?page=${page}&size=${size}`, {
          ...filteredListParams
        });
  }

  fetchBlockchainDashboard(filteredListParams: {
      boardId: number,
      lotteryId: number,
      schemeId: number,
    }) {
    return this.httpClient.post<BlockchainDashboardModel>(
        ApiUrls.blockchainDashboardUrl, {
          ...filteredListParams
        });
  }
  
  fetchBlockchainDashboardChart(filteredListParams: {
    boardId: number,
    lotteryId: number,
    schemeId: number,
    chartYear: number
    }) {
    return this.httpClient.post<BlockchainDashboardModel>(
        ApiUrls.blockchainDashboardChartUrl, {
          ...filteredListParams
        });
  }

  pushBCDocs(applicationNo: string, bcDocType: string) {
    return this.httpClient.get<{status: string, errorMessage: string}>(
      ApiUrls.blockchainPushDocUrl.replace('{applicationNo}', applicationNo).replace('{bcDocType}', bcDocType));
  }

  fetchPendingList(page: number, size: number) {
    return this.httpClient.get<{data: Page<BlockchainPendingDocsView>, status: string, errorMessage: string}>(
      ApiUrls.fetchPendingBlockchainDocumentsUrl + `?page=${page}&size=${size}`);
  }

  initFormFetchBoard() {
    return this.httpClient.get<{lst: {[key: number]: string}, status: string, errorMessage: string}>(
      ApiUrls.verifyBlockchainInitFormBoardListUrl);
  }

  initFormFetchLottery(boardId: number) {
    return this.httpClient.get<{lst: {[key: number]: string}, status: string, errorMessage: string}>(
      ApiUrls.verifyBlockchainInitFormLotteryListUrl.replace('{boardId}', boardId.toString()));
  }

  initFormFetchScheme(boardId: number, lotteryId: number) {
    return this.httpClient.get<{lst: {[key: number]: string}, status: string, errorMessage: string}>(
      ApiUrls.verifyBlockchainInitFormSchemeListUrl.replace('{boardId}', boardId.toString())
      .replace('{lotteryId}', lotteryId.toString())
      );
  }

  viewDocument(blockchainId: number) {
    return this.httpClient.get<{data: string, status: string, fileName: string, errorMessage: string}>(
      ApiUrls.blockchainViewDocumentUrl.replace("{blockchainId}", blockchainId.toString()));
  }

  verifyFetchDetail(blockchainId: number) {
    return this.httpClient.get<BlockchainDetailModelResponse>(
      ApiUrls.verifyBlockchainFetchDetailUrl.replace("{blockchainId}", blockchainId.toString()));
  }

  auditTrail(blockchainId: number) {
    return this.httpClient.get<BlockchainAuditAssetWrapperResponse>(
      ApiUrls.blockchainAuditTrailUrl.replace("{blockchainId}", blockchainId.toString()));
  }

  verify(blockchainId: number) {
    return this.httpClient.get<{peersVerificationResponse: {[key: string]: string}, status: string, errorMessage: string}>(
      ApiUrls.verifyBlockchainUrl.replace("{blockchainId}", blockchainId.toString()));
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}
